import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = "/api/pdf.worker.min.mjs";

